const defaultState = {
  cities: [],
  selectedCity: null
};

export default defaultState;
